module.exports = __webpack_public_path__ + "img/hr-V-R-5-load-standup-shadow.78b724b3.png";